// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--60592";
export var container = "style-module--container--0fd5a";
export var develop = "style-module--develop--854ac";
export var experts = "style-module--experts--ab4d5";
export var gray = "style-module--gray--c241f";
export var orange = "style-module--orange--b77f7";
export var partners = "style-module--partners--f3a9d";
export var violet = "style-module--violet--8cf1a";